/**
 * SSO silencieux Assowee (prompt=none).
 * Navigation pleine page uniquement — pas d'iframe.
 * Un échec n'est pas relancé pendant la même visite (sessionStorage).
 */

export const SILENT_SSO_FAILED_KEY = 'inventwee_sso_silent_failed';
export const SSO_RETURN_TO_KEY = 'inventwee_sso_return_to';

const SILENT_ERRORS = new Set([
  'login_required',
  'interaction_required',
  'consent_required',
  'oauth2_login_required',
  'oauth2_interaction_required',
  'oauth2_consent_required',
]);

export function isSilentSsoInteractionError(code: string | null | undefined): boolean {
  if (!code) return false;
  return SILENT_ERRORS.has(code);
}

export function hasSilentSsoFailedThisVisit(): boolean {
  try {
    return sessionStorage.getItem(SILENT_SSO_FAILED_KEY) === '1';
  } catch {
    return false;
  }
}

export function markSilentSsoFailedThisVisit(): void {
  try {
    sessionStorage.setItem(SILENT_SSO_FAILED_KEY, '1');
  } catch {
    /* mode privé */
  }
}

export function clearSilentSsoFailedFlag(): void {
  try {
    sessionStorage.removeItem(SILENT_SSO_FAILED_KEY);
  } catch {
    /* mode privé */
  }
}

export function rememberSsoReturnTo(pathWithSearch: string): void {
  try {
    const safe = isSafeAppReturnTo(pathWithSearch);
    if (!safe) return;
    sessionStorage.setItem(SSO_RETURN_TO_KEY, safe.slice(0, 512));
  } catch {
    /* mode privé */
  }
}

export function consumeSsoReturnTo(fallback = '/'): string {
  try {
    const stored = sessionStorage.getItem(SSO_RETURN_TO_KEY);
    sessionStorage.removeItem(SSO_RETURN_TO_KEY);
    if (stored && isSafeAppReturnTo(stored)) {
      return stored;
    }
  } catch {
    /* mode privé */
  }
  return fallback;
}

export function isSafeAppReturnTo(raw: string | null | undefined): string | undefined {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) {
    return undefined;
  }
  if (raw.includes('://') || raw.includes('\\')) {
    return undefined;
  }
  const pathOnly = raw.split('?')[0].split('#')[0];
  if (
    pathOnly === '/login' ||
    pathOnly.startsWith('/login/') ||
    pathOnly.startsWith('/auth/')
  ) {
    return undefined;
  }
  return raw;
}

/** Navigation interactive : retire prompt=login s'il était présent. */
export function authorizeUrlWithoutForcedLogin(authUrl: string): string {
  const url = new URL(authUrl);
  if (url.searchParams.get('prompt') === 'login') {
    url.searchParams.delete('prompt');
  }
  return url.toString();
}
